import Barrier from "@object-generators/safety-barrier/objects/barrier";
import {
  SET_BARRIER_DPOT,
  SET_BARRIER_HEIGHT,
  SET_BARRIER_OPTIONS,
  SET_BARRIER_SHAPE,
  SET_BARRIER_LOADS_EXTERNAL,
  SET_BARRIER_LOADS_INTERNAL,
  RESET_BARRIER,
  SET_BARRIER_STATE
} from '@reducers/options/barrier/actions';

// import Scene from '@scene';
import { initState as initDimensionState} from '@reducers/selectors/dimension/index';
// import merge from '@services/deepmerge';
import { mergeDeep } from "@services/helper.service";
import { APP_TYPES } from "@config";

const initState = {
  type: Barrier.types.STAIRS,
  profileFamily: Barrier.types.profile.SQUARE_BARS,
  dpot: initDimensionState[APP_TYPES.SAFETY_BARRIER].safetyBarrierDimensions.dpot,
  tilt: 0,
  stayCount: 3,
  barrierPadding: 100,
  height: initDimensionState[APP_TYPES.SAFETY_BARRIER].safetyBarrierDimensions.hgc,
  baseOffset: 0,
  depth: 5,
  stayWidth: 5,
  bottomPadding: 300,
  shape: null,

  loads: {
    external: {
      active: true,
      value: 0.6,
      isCustom: false
    },
    internal: {
      active: true,
      value: 0.4, // default 40 daN
      isCustom: true
    }
  }
};

const barrier = (state = mergeDeep({}, initState), action) => {
  switch (action.type) {
    case SET_BARRIER_HEIGHT: {
      return mergeDeep({}, state, {
        height: action.value
      });
      // state.height = action.value;

      // Scene.updateBarrier(state);

      // return { ...state };
    }
    case SET_BARRIER_DPOT: {
      return mergeDeep({}, state, {
        dpot: action.value
      });
      // state.dpot = action.value;

      // Scene.updateBarrier(state);

      // return { ...state };
    }
    case SET_BARRIER_SHAPE: {
      state.shape = null;
      state.profileFamily = Barrier.types.profile.SHAPE;

      return mergeDeep({}, state, {
        shape: action.value
      });
    }
    case SET_BARRIER_OPTIONS: {
      return mergeDeep({}, state, action.options);
    }
    case SET_BARRIER_LOADS_EXTERNAL: {
      return mergeDeep({}, state, {
        loads: {
          external: {
            active: !!action.value,
            value: action.value,
            isCustom: !!action.isCustom
          }
        }
      });
    }
    case SET_BARRIER_LOADS_INTERNAL: {
      return mergeDeep({}, state, {
        loads: {
          internal: {
            active: action.isActive,
            value: action.value
          }
        }
      });
    }
    case RESET_BARRIER: {
      return mergeDeep({}, initState);
    }
    case SET_BARRIER_STATE: {
      return action.state;
    }
    default: {
      return state;
    }
  }
};

export default barrier;



// WEBPACK FOOTER //
// ./src/reducers/options/barrier/index.js